import scssConstants from 'widgets/tiles/components/styles/variables.module.scss';

export const styleConstants = {
    tileHeight: parseInt(scssConstants.tileHeight),
    tileWidth: parseInt(scssConstants.tileWidth),
    squareTileWidth: parseInt(scssConstants.squareTileWidth),
    tileWidgetToolbarHeight: parseInt(scssConstants.tileWidgetToolbarHeight),
    tileWidgetToolbarMarginTop: parseInt(
        scssConstants.tileWidgetToolbarMarginTop
    ),
};
